module.exports = __webpack_public_path__ + "img/bullet_impact.7bc91f11.png";